import { ReactNode } from 'react';
import { Heading, Text } from '@frontend/design-system';
import { StackedCardWizardFooter } from './stacked-card-wizard-footer';
import { StackedCardWizardStep as BaseWizardStep } from './stacked-card-wizard-step';

interface StackedCardWizardStepProps {
  children: ReactNode;
  stepId: string;
  canGoNext?: boolean;
  onNext?: () => void | Promise<void>;
}

const StackedCardWizardStepRoot = ({ children, stepId, canGoNext, onNext }: StackedCardWizardStepProps) => {
  return (
    <BaseWizardStep stepId={stepId} canGoNext={canGoNext} onNext={onNext}>
      {children}
    </BaseWizardStep>
  );
};

interface StepHeaderProps {
  title?: string;
  description?: string;
  children?: ReactNode;
}

const StepHeader = ({ title, description, children }: StepHeaderProps) => {
  if (children) {
    return <div>{children}</div>;
  }

  return (
    <div>
      <Heading level={2}>{title}</Heading>
      <Text weight='regular'>{description}</Text>
    </div>
  );
};

interface StepContentProps {
  children: ReactNode;
}

const StepContent = ({ children }: StepContentProps) => {
  return <div css={{ width: '100%' }}>{children}</div>;
};

interface StepFooterProps {
  children?: ReactNode;
}

const StepFooter = ({ children }: StepFooterProps) => {
  return <div>{children || <StackedCardWizardFooter />}</div>;
};

export const StackedCardWizardStep = Object.assign(StackedCardWizardStepRoot, {
  Header: StepHeader,
  Content: StepContent,
  Footer: StepFooter,
});

export { StepHeader, StepContent, StepFooter };
